import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Chip,
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import contries from "../../Roles and Permissions/Country.json";
import PhoneField from "../../../../Components/Masters/PhoneField";
import AutoComplete from "../../../../Components/Common/AutoComplete";
import EditDialog from "../../../../Components/Common/EditDialog";
import { validateNumber } from "../../../../utils/validateFields";
import { post, put } from "../../../../utils/api";
import PhoneFieldInput from "../../../../Components/Masters/PhoneFieldInput";
import AddIcon from "@mui/icons-material/Add";
import AddTable from "./AddTables";
import { typeofemissions } from "../../../../utils/constant";
import { Delete } from "@mui/icons-material";
import DeleteRowDialog from "../../../../Components/Common/DeleteRowDialog";

function Add({
  inputData,
  fetchData,
  id,
  element,
  data,
  setAddData,
  addData,
  simpleUnits,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const [errors, setErrors] = useState({});
  const [units, setUnits] = useState([]);
  const [processTimeout, setProcessTimeout] = useState(null);
  const initialState = {
    date:
      id && element
        ? new Date(element?.date)?.toISOString()?.split("T")[0]
        : new Date().toISOString().split("T")[0],
    productName: id && element ? element?.productName : "",
    productId: id && element ? element?.productId : "",
    productCategory: id && element ? element?.productCategory : "",
    productDescription: id && element ? element?.productDescription : "",
    averageWeightPerUnit: id && element ? element?.averageWeightPerUnit : "",
    averageWeightPerUnitUnit:
      id && element ? element?.averageWeightPerUnitUnit : "",
    frequencyOfMaintenancePerYear:
      id && element ? element?.frequencyOfMaintenancePerYear : "",
    energyOrFuelUsedForMaintenance:
      id && element ? element?.energyOrFuelUsedForMaintenance : "",
    energyOrFuelUsedForMaintenanceUnit:
      id && element ? element?.energyOrFuelUsedForMaintenanceUnit : "",
    disposalMethod: id && element ? element?.disposalMethod : "",
    expectedLifetimeOfTheProductYears:
      id && element
        ? element?.expectedLifetimeOfTheProductYears ||
          element?.expectedLifetimeOfProduct
        : "",
    sampleBasis: id && element ? element?.sampleBasis : "",
    sampleQuantity: id && element ? element?.sampleQuantity : "",
    unit: id && element ? element?.unit : "",
    processes:
      id && element && Array.isArray(element?.processes)
        ? element.processes.map((proc) => ({
            processName: proc.processName || "",
            airEmissions: proc.airEmissions || [],
            emissions: Array.isArray(proc.emissions)
              ? proc.emissions.map((e) => ({
                  emissionsName: e.emissionsName || "",
                  unit: e.unit || "",
                  quantity: e.quantity || "",
                }))
              : [{ emissionsName: "", unit: "", quantity: "" }],
          }))
        : [
            {
              processName: "",
              airEmissions: [],
              emissions: [{ emissionsName: "", unit: "", quantity: "" }],
            },
          ],
  };

  const [openDialog, setOpenDialog] = React.useState(false);
  const [formData, setFormData] = useState(initialState);
  // Time state
  const [table, setTable] = useState([]);
  const [editDialog, setEditDialog] = useState(false);
  const [formData2, setFormData2] = useState(initialState);
  const [processEmission, setProcessEmission] = useState([
    {
      processName: "",
      emissions: [{ emissionsName: "", unit: "", quantity: "" }],
    },
  ]);
  const [removeIndex, setRemoveIndex] = useState("");

  const mappedProcesses = element?.processes?.map((process, index) => ({
    ...process,
    processName: process?.processName || "",
    airEmissions: process?.airEmissions || [],
    emissions: (process?.emissions || []).map((emission) => ({
      emissionsName: emission?.name || emission?.emissionsName || "",
      unit: emission?.unit || "",
      quantity: emission?.quantity || "",
    })),
  })) || [
    {
      processName: "",
      airEmissions: [],
      emissions: [{ emissionsName: "", unit: "", quantity: "" }],
    },
  ];
  useEffect(() => {
    resetForm();
  }, [element, id]);

  const resetForm = () => {
    if (id && element) {
      // Existing edit mode logic
      setFormData({
        ...initialState,
        processes: mappedProcesses,
      });
      setFormData2({
        ...initialState,
        processes: mappedProcesses,
      });
      setTable(
        mappedProcesses.map((process, index) => ({
          index,
          processName: process.processName,
          airEmissions: process.airEmissions,
          emissions: process.emissions,
          colspan: process.emissions.length || 1,
        }))
      );
      setProcessEmission(mappedProcesses);
    } else {
      // Add mode - initialize with one empty row
      const emptyRow = {
        processName: "",
        airEmissions: [],
        emissions: [{ emissionsName: "", unit: "", quantity: "" }],
      };

      setFormData({
        ...initialState,
        processes: [emptyRow],
      });
      setFormData2({
        ...initialState,
        processes: [emptyRow],
      });
      setTable([
        {
          index: 0,
          processName: "",
          airEmissions: [],
          emissions: [{ emissionsName: "", unit: "", quantity: "" }],
          colspan: 1,
        },
      ]);
      setProcessEmission([emptyRow]);
    }
  };

  useEffect(() => {
    if (formData.sampleBasis) {
      const unitOptions =
        simpleUnits.find(
          (unit) => Object.keys(unit)[0] === formData.sampleBasis
        )?.[formData.sampleBasis] || [];

      console.log("unitOptions:", unitOptions);
      setUnits(unitOptions);
    } else {
      setUnits([]);
    }
  }, [formData.sampleBasis, simpleUnits]);

  useEffect(() => {
    return () => {
      if (processTimeout) clearTimeout(processTimeout);
    };
  }, []);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    const [baseField, field, rawIndex] = name.split(".");

    // Update form data
    if (name === "sampleQuantity") {
      if (!/^\d*\.?\d*$/.test(value)) return;
    }

    const index = parseInt(rawIndex, 10);

    setFormData((prevState) => {
      if (baseField === "processes") {
        return {
          ...prevState,
          [baseField]: prevState[baseField]?.map((item, idx) => {
            return idx === index ? { ...item, [field]: value } : item;
          }),
        };
      } else {
        return {
          ...prevState,
          [name]: value,
        };
      }
    });

    // Clear errors for this field
    setErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));

    if (baseField === "processes") {
      if (processTimeout) clearTimeout(processTimeout);

      const newTimeout = setTimeout(async () => {
        if (value.trim() === "") return;

        setTable((prevTable) => {
          const updatedTable = [...prevTable];
          const rowIndex = updatedTable.findIndex((row) => row.index === index);

          if (rowIndex >= 0) {
            // Update existing row
            updatedTable[rowIndex].processName = value;
          } else {
            // This else block was creating new rows unnecessarily
            // We shouldn't need this since we're only updating existing rows
            console.warn("Trying to update non-existent row");
          }

          return updatedTable;
        });
      }, 600); // Debounce delay

      setProcessTimeout(newTimeout);
    }
  };

  const handleChangeEmission = async (name, value) => {
    const [baseField, field, rawIndex] = name.split(".");
    console.log(name, baseField, field, value, "handleChangeEmission");
    const index = parseInt(rawIndex, 10);

    setFormData((prevState) => {
      if (baseField === "processes") {
        return {
          ...prevState,
          [baseField]: prevState[baseField]?.map((item, idx) => {
            if (idx !== index) return item;
            if (field === "emissions") {
              const mappedEmissions = (value || []).map((val, idx) => {
                const previous = item.emissions?.[idx] || {};
                return {
                  emissionsName:
                    typeof val === "object"
                      ? val.emissionsName || val.name || val
                      : val,
                  unit: previous.unit || "",
                  quantity: previous.quantity || "",
                };
              });

              return {
                ...item,
                airEmissions: value || [],
                emissions: [...mappedEmissions],
              };
            }

            return {
              ...item,
              [field]: value,
            };
          }),
        };
      } else {
        return {
          ...prevState,
          [name]: value,
        };
      }
    });
    console.log(baseField, field, index, "baseField", errors);
    if (baseField === "processes") {
      setTable((prevTable) => {
        const updatedTable = [...prevTable];
        const emissionKey = `processes.emissions.${index}`;
        const emissions = value || [];
        console.log(emissions, "formData[emissionKey]");
        const rowIndex = updatedTable.findIndex((row) => row.index === index);

        if (rowIndex >= 0) {
          updatedTable[rowIndex].emissions = emissions.reduce(
            (acc, item, idx) => {
              if (!Array.isArray(acc)) acc = [];
              acc.push({
                emissionsName: item.name || item, // Fallback if item is a string
                quantity: item.quantity || "",
                unit: item.unit || "",
              });
              return acc;
            },
            []
          );
          updatedTable[rowIndex].colspan = emissions.length || 1;
        }

        return updatedTable;
      });
    }

    console.log(errors, baseField, "abcd");
    setErrors((prevState) => ({
      ...prevState,
      [`airEmissions.${index}`]: "", // clear specific field
    }));
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    console.log(initialState, "initial");
    resetForm();
  };

  const inputTableData = [
    {
      title: "Process Name",
      colwidth: "28%",
      filedName: "processes",
      placeholder: "Process Name",
    },
    {
      title: "Emission",
      field: "emissions",
      placeholder: "Emission",
    },
    {
      title: "Quantity",
      field: "quantity",
      type: "number",
      placeholder: "Enter Quantity",
    },
    {
      title: "Unit",
      field: "unit",
      type: "select",
      placeholder: "Unit",
    },
  ];

 const handleClose = () => {
  const isFormDataUnchanged = Object.keys(formData).every((key) => {
    if (key === "processes") {
      // Deep compare the processes array
      return JSON.stringify(formData.processes) === JSON.stringify(formData2.processes);
    } else {
      // Simple compare for primitive fields
      return formData[key] === formData2[key];
    }
  });

  console.log(isFormDataUnchanged, formData, formData2, "key1");

  if (isFormDataUnchanged) {
    handleExitAgree();
  } else {
    setEditDialog(true);
  }
};


  const validateForm = () => {
    const newErrors = {};

    inputData.forEach((input) => {
      // If input itself is an array, loop through each item in it
      console.log(Array.isArray(input), "Array.isArray(input)");
      if (Array.isArray(input)) {
        input.forEach((fields) => {
          const value =
            formData[
              fields.fieldName.includes(".")
                ? fields.fieldName.split(".")[0]
                : fields.fieldName
            ];
          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              if (fields.fieldName.includes("processes")) {
                if (!item.processName || item.processName.trim() === "") {
                  newErrors[`processes.processName.${index}`] =
                    "Process name is required.";
                }

                // validate airEmissions if needed
                if (!item.airEmissions || item.airEmissions.length === 0) {
                  newErrors[`airEmissions.${index}`] =
                    "At least one emission type is required.";
                }

                if (
                  item?.processName !== "" &&
                  item?.airEmissions?.length > 0
                ) {
                  item.emissions.forEach((emission, i) => {
                    if (!emission.emissionsName) {
                      newErrors[`emissionsName_${index}_${i}`] =
                        "Emission name is required.";
                    }
                    if (!emission.unit) {
                      newErrors[`unit_${index}_${i}`] = "Unit is required.";
                    }
                    if (!emission.quantity) {
                      newErrors[`quantity_${index}_${i}`] =
                        "Quantity is required.";
                    }
                  });
                }
              }
            });
          } else if (!value || value === "") {
            newErrors[fields.fieldName] = "This field is required.";
          }
        });
      } else {
        // If the field is an array in formData (like processes), validate accordingly
        const value = formData[input.fieldName];

        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (input.fieldName.includes("processes")) {
              if (!item.processName || item.processName.trim() === "") {
                newErrors[`processes.processName_${index}`] =
                  "Process name is required.";
              }

              // validate airEmissions if needed
              if (!item.airEmissions || item.airEmissions.length === 0) {
                newErrors[`airEmissions_${index}`] =
                  "At least one emission type is required.";
              }

              item.emissions.forEach((emission, i) => {
                if (!emission.emissionsName) {
                  newErrors[`emissionsName_${index}_${i}`] =
                    "Emission name is required.";
                }
                if (!emission.unit) {
                  newErrors[`unit_${index}_${i}`] = "Unit is required.";
                }
                if (!emission.quantity) {
                  newErrors[`quantity_${index}_${i}`] = "Quantity is required.";
                }
              });
            }
          });
        }
      }
    });
    console.log(newErrors, "newErrors");
    setErrors({ ...errors, ...newErrors });

    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    console.log(validateForm(), "validateForm()for the validation");
    if (!validateForm()) return;
    const datasend = {};
    console.log(formData, "checking formData");
    let method = id ? put : post;
    let url = id ? `${updateUrl}/${id}` : addUrl;

    await method(url, formData)
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        handleExitAgree();
      })
      .catch((err) => {
        if (err.response.data.message === "Product already exists")
          setErrors((prev) => ({
            ...prev,
            productName: "Product already exists.",
          }));
        console.log(err.response.data?.message, "err1");
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });
  };

  const isFilled = () => {
    let data = formData?.processes?.[formData?.processes?.length - 1];
    console.log(formData, data, "formData");
    if (data?.processName !== "" && data?.airEmissions?.length !== 0)
      return false;
    return true;
  };
  const handleAdd = () => {
    const newItem = {
      processName: "",
      airEmissions: [],
      emissions: [{ emissionsName: "", unit: "", quantity: "" }],
    };

    setProcessEmission((prev) => [...prev, newItem]);
    setFormData((prevState) => ({
      ...prevState,
      processes: [...prevState.processes, newItem],
    }));

    // Also update the table state
    setTable((prev) => [
      ...prev,
      {
        index: prev.length,
        processName: "",
        airEmissions: [],
        emissions: [{ emissionsName: "", unit: "", quantity: "" }],
        colspan: 1,
      },
    ]);
  };

  const handleDelete = (index) => {
    if (formData.processes?.length <= 1) {
      return;
    }
    const process = formData?.processes?.[index];
    console.log(process, "process");
    if (process?.airEmissions?.length === 0 && process?.processName === "") {
      setFormData((prevState) => ({
        ...prevState,
        processes: prevState.processes?.filter((_, i) => i !== index), // Simplified filter
      }));

      setProcessEmission((prev) => prev.filter((_, i) => i !== index)); // Simplified filter
      setTable((prev) => prev.filter((_, i) => i !== index)); // Simplified filter
      setOpenDialog(false);
      setRemoveIndex("");
      setErrors((prev) => ({ ...prev }));
    } else {
      setRemoveIndex(index);

      setOpenDialog(true);
    }
  };

  const cancelRemoveRow = () => {
    setOpenDialog(false);
  };

  const confirmRemoveRow = () => {
    setFormData((prevState) => ({
      ...prevState,
      processes: prevState.processes?.filter((_, i) => i !== removeIndex), // Simplified filter
    }));

    setProcessEmission((prev) => prev.filter((_, i) => i !== removeIndex)); // Simplified filter
    setTable((prev) => prev.filter((_, i) => i !== removeIndex)); // Simplified filter
    setOpenDialog(false);
    setRemoveIndex("");
    setErrors((prev) => ({ ...prev }));
  };
  const renderInputField = (el) => {
    console.log(el, "el");
    if (Array.isArray(el)) {
      const hasHeader = el.some((item) => item.header);
      return (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            gap: "8px",
            width: "100%",
          }}
        >
          {hasHeader && (
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", width: "100%", mb: 1 }}
            >
              {el.find((item) => item.header)?.header}
            </Typography>
          )}

          {el.map((item) => {
            return (
              <Box sx={{ width: item.colwidth || "100%" }}>
                {item.type === "select" ? (
                  <SelectField
                    title={item.title}
                    name={item.fieldName}
                    value={formData[item.fieldName]}
                    //   handleChange={handleCountryChange}
                    handleChange={handleChange}
                    options={item.options}
                    errors={errors[item.fieldName]}
                    labelMinHeight={item.labelMinHeight}
                  />
                ) : item.fieldName === "unit" ? (
                  <SelectField
                    title={item.title}
                    name={item.fieldName}
                    value={formData[item.fieldName]}
                    //   handleChange={handleCountryChange}
                    handleChange={handleChange}
                    options={units || []}
                    errors={errors[item.fieldName]}
                    labelMinHeight={item.labelMinHeight}
                  />
                ) : (
                  <InputField
                    title={item.title}
                    handleChange={handleChange}
                    placeholder={item.placeholder}
                    value={formData[item.fieldName] || ""}
                    errors={errors[item.fieldName]}
                    fieldName={item.fieldName}
                    labelMinHeight={item.labelMinHeight}
                  />
                )}
              </Box>
            );
          })}
        </Box>
      );
    }

    if (el.header) {
      return (
        <Typography
          // key={idx}
          variant="subtitle1"
          sx={{ fontWeight: "bold", width: "100%", mt: 2 }}
        >
          {el.header}
        </Typography>
      );
    }
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "40.6rem" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <DeleteRowDialog {...{ openDialog, cancelRemoveRow, confirmRemoveRow }} />
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "3%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          width: "100%",
          pl: 3,
          pr: 1,
          py: "1.5rem",
          backgroundColor: "#fff",
          height: "100vh",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? "Edit Product" : "Add Product"}
        </Typography>
        <Box display="flex" flexWrap="wrap">
          {inputData.slice(0, -1).map((el, index) => renderInputField(el))}
          {processEmission.map((item, index) => {
            return (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px",
                  width: "100%",
                  alignItems: "flex-start", // Align items at the top
                  position: "relative", // Make this a positioning context
                  mb: "-1.2rem",
                }}
              >
                {/* Main content box */}
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    flexDirection: "row",
                    gap: "8px",
                    width: "calc(100% - 40px)", // Reserve space for delete button
                  }}
                >
                  {inputData[3].map((item, idx) => (
                    <Box sx={{ width: item.colwidth || "100%" }}>
                      {console.log(item, formData?.processes, "item1")}

                      {item.fieldName === "processes.emissions" ? (
                        <>
                          <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "bold", mt: 1 }}
                          >
                            {item.title}
                          </Typography>
                          <Autocomplete
                            multiple
                            disablePortal
                            size="small"
                            displayEmpty
                            options={typeofemissions}
                            disabled={
                              formData.processes[index]?.processName === ""
                            }
                            value={
                              formData?.processes[index]?.airEmissions || []
                            }
                            onChange={(_, newValue) =>
                              handleChangeEmission(
                                `${item.fieldName}.${index}`,
                                newValue
                              )
                            }
                            getOptionLabel={(option) => option}
                            renderTags={() => null}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                placeholder={
                                  (
                                    formData?.processes[index]?.airEmissions ||
                                    []
                                  ).length === 0
                                    ? "Tap to Select"
                                    : ""
                                }
                                error={!!errors[`airEmissions.${index}`]}
                                // helperText={errors[`airEmissions.${index}`]}
                              />
                            )}
                            sx={{
                              width: "100%",
                              "& .MuiAutocomplete-inputRoot": {
                                height: 40,
                                alignItems: "center",
                              },
                              "& .MuiAutocomplete-tag": {
                                display: "none",
                              },
                            }}
                          />
                          {errors[`airEmissions.${index}`] && (
                            <Typography variant="body2" color="#D34040">
                              {errors[`airEmissions.${index}`]}
                            </Typography>
                          )}
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              minHeight: "40px", // Fixed height for chip container
                              alignItems: "flex-start",
                              marginBottom: "8px", // Add some space below
                            }}
                          >
                            {formData?.processes[index]?.airEmissions?.map(
                              (value) => (
                                <Chip
                                  key={value}
                                  label={value}
                                  sx={{
                                    bgcolor: "#1C486B",
                                    color: "white",
                                    height: "28px",
                                    m: 0.25,
                                    "& .MuiChip-deleteIcon": {
                                      color: "white",
                                      "&:hover": {
                                        color: "white",
                                      },
                                    },
                                  }}
                                  onDelete={() =>
                                    handleChangeEmission(
                                      `${item.fieldName}.${index}`,
                                      formData?.processes[
                                        index
                                      ]?.airEmissions?.filter(
                                        (v) => v !== value
                                      )
                                    )
                                  }
                                />
                              )
                            )}
                          </Box>
                        </>
                      ) : (
                        <InputField
                          title={item.title}
                          handleChange={handleChange}
                          placeholder={item.placeholder}
                          value={formData?.processes[index]?.processName || ""}
                          errors={errors[`${item.fieldName}.${index}`]}
                          helperText={errors[`${item.fieldName}.${index}`]}
                          fieldName={`${item.fieldName}.${index}`}
                        />
                      )}
                    </Box>
                  ))}
                </Box>

                {/* Delete button positioned absolutely */}
                <IconButton
                  sx={{
                    position: "absolute",
                    right: 0,
                    top: 0,
                    mt: 4,
                    // ml: "0.5rem"
                  }}
                  disabled={formData?.processes?.length === 1}
                  onClick={() => handleDelete(index)}
                  color="error"
                >
                  <Delete />
                </IconButton>
              </Box>
            );
          })} 

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              disabled={isFilled()}
              variant="contained"
              onClick={handleAdd}
              sx={{
                mt: "0rem",
                backgroundColor: "#1C486B",
                color: "white",
              }}
            >
              <AddIcon />
              Add New Process
            </Button>
          </Box>
        </Box>
        <Box>
          {/*
            Unit dropdown in "Emission Release in Processes" table should only show Mass units.
            Allowed: ["Gram", "Kilogram", "Metric Tonne", "Milligram"]
          */}
          {(() => {
            const massUnits = simpleUnits?.find((u) => u?.Mass)?.Mass || [
              "Gram",
              "Kilogram",
              "Metric Tonne",
              "Milligram",
            ];

            return (
          <AddTable
            inputData={inputTableData}
            title={"Emission Release in Processes"}
            table={table || [{}]}
            formData={formData}
            setFormData={setFormData}
            setTable={setTable}
            units={massUnits}
            errors={errors}
            setErrors={setErrors}
          />
            );
          })()}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default Add;
